import type { Member, MemberRole } from '../types';

export function memberRole(member: Member | null | undefined): MemberRole | null {
  return member?.role ?? null;
}

export function isUser(member: Member | null | undefined): boolean {
  return member?.role === 'user';
}

export function isMember(member: Member | null | undefined): boolean {
  return member?.role === 'member';
}

export function isAdmin(member: Member | null | undefined): boolean {
  return member?.role === 'admin';
}

export function isOrganizer(member: Member | null | undefined): boolean {
  return member?.role === 'organizer';
}

/** Admin-only management routes (/members, full /admin). */
export function canAccessAdminRoutes(member: Member | null | undefined): boolean {
  return isAdmin(member);
}

/** Events, registrations, and allowlisted scoring. Not the rest of admin. */
export function canAccessOrganizerRoutes(member: Member | null | undefined): boolean {
  return isOrganizer(member);
}

export function roleDisplayLabel(role: MemberRole): string {
  if (role === 'admin') return 'Administrator';
  if (role === 'organizer') return 'Organizer';
  if (role === 'member') return 'Verified member';
  return 'Registered user';
}
